import React, {useState,  useEffect } from 'react';
import DeckGL from 'deck.gl';
import { CSVLoader } from '@loaders.gl/csv';

import zipLoader from './zipLoader'


import { renderLayers } from "./RenderLayers";

// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    latitude: 38.17235759245721,
    longitude: 136.85153168318723,
    bearing: 0,
    pitch: 0,
    zoom: 5
};


function Map() {
    const [data, setData] = useState(null)
    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE)


    useEffect(() => {
        const loadData = async (url) => {
            const res = await zipLoader(url, CSVLoader, (d) => {
                //console.log(d) //ローディング処理
            })
            setData(res)
        }

        loadData("./data/over65point.zip")

    }, [])


    return (
        <div>
            <DeckGL
                initialViewState={viwState}
                controller={true}
                layers={renderLayers({ data })}
                onViewStateChange={(v)=>console.log(v.viewState)}
            >
            </DeckGL>
            <fieldset>
                <legend>Population Ratio</legend>
                <ul>
                    <li className="over65" >Age 65+ <span style={{marginRight:"0.5em"}}>{'>'}</span> 50%</li>
                    <li className="under65">Age 65+ <span>{'<='}</span> 50%</li>
                </ul>                
            </fieldset>
            
            <div className="attribution">
                source：<a
                    href="https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-mesh500h30.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                国土数値情報
                </a>
            </div>
        </div>
    );
}

export default Map;